import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: []
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/exampackage/footer/footer.component.ts